<template>
    <div v-if="showModal" id="rg_card" class="rg-card">
        <div class="contact-form-box shadow-box">
            <svg @click.stop="showModal = false" class="closed" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            <h4 class="mb--10">Gana en promedio el {{ isMounted ? (rgStats.net_yield || 0) : '--' }}%* anual.</h4>
            <button @click.stop="goToInvetorOnboarding()" class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button"
                name="submit-btn">Comenzar a invertir</button>
        </div>
    </div>
</template>

<script>

export default {
    name: "ButtonCard",
    props: ["rgStats", "isMounted"],
    data() {
        return  {
            investorUrlBase: process.env.VUE_APP_REGISTER_INVESTOR_URL,
            showModal: true
        }
    },
    mounted() {
        const rgCard = $('#rg_card');
        // console.log(rgCard);
        $(window).on('scroll', function() {
            // console.log($(window).scrollTop())
            if ($(window).scrollTop() > 300 &&  $(window).scrollTop() < 7500) {
                rgCard.addClass('show');
            } else {
                rgCard.removeClass('show');
            }

        });
    },
    methods: {
        goToInvetorOnboarding()
        {
            window.open(`${this.investorUrlBase}/`, "_blank");
        }
    }
}

</script>

<style scoped>
.rg-card {
    position: fixed !important;
    position: absolute;
    bottom: 4rem;
    margin-left: -2rem;
    margin-right: 10rem;
    z-index: 99;
    opacity: 0;
    -webkit-transform: scale(0.3);
    -ms-transform: scale(0.3);
    transform: scale(0.3);
    z-index: 9;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.rg-card.show {
    /* bottom: 40px;
    right: 40px; */
    opacity: 1;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
}

.closed {
    position: absolute;
    float: right;
    top: 30px;
    right: 38px;
    cursor: pointer;
}
</style>